import axios from 'axios';
import { API_RESULT } from '../../modules/api';

const acceptCookiePolicy = () => dispatch => {
  axios.post('/api/cookie_policy').then(response => dispatch({ payload: response.data, type: API_RESULT }));
};

export default acceptCookiePolicy;
